import React, {ReactElement} from 'react';
import clsx from 'clsx';

import {useTranslation} from 'react-i18next';

import styles from './Instruction.module.css';

interface PaymentInstructionProps {
  className?: string
  instructions: string[]
  renderListStyle?: (instruct: string) => ReactElement
}


const Instruction = ({instructions, className, renderListStyle}: PaymentInstructionProps) => {
  const {t} = useTranslation();

  const willRenderCustomIcon = typeof renderListStyle === 'function';

  return (
    <ul className={clsx(styles.root, !willRenderCustomIcon && styles.hasIcon, className)}>
      {
        instructions.map((instruction) => {
          return (
            <li key={instruction} className={styles.item}>
              <div className={styles.itemInside}>
                {willRenderCustomIcon ? renderListStyle!(instruction) : null}
                <div className={styles.listContent}>{t(instruction)}</div>
              </div>
            </li>
          )
        })
      }
    </ul>
  );
};

export default Instruction;